import request from '../request'

export const fileApi = {
  // 获取所有文件
  getAllFiles () {
    return request.get('files/getAllFiles')
  },

  // 获取文件类型
  getFileTypes () {
    return request.get('fileType/allType')
  },

  // 上传文件
  uploadFiles (fileList) {
    const formData = new FormData()
    fileList.forEach((val, index) => {
      formData.append('fileList', val.raw)
    })
    return request.post('files/saveFileList', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },

  // 删除文件
  deleteFile (id) {
    return request.get('files/deleteById', { params: { id } })
  },

  // 更新文件类型
  updateFileType (fileId, typeId) {
    return request.get('files/updateFileType', { params: { fileId, typeId } })
  },

  // 添加文件类型
  addFileType (name) {
    return request.get('fileType/addType', { params: { name } })
  },

  // 删除文件类型
  deleteFileType (id) {
    return request.get('fileType/deleteType', { params: { id } })
  },

  // 更新文件类型名称
  updateFileTypeName (data) {
    return request.post('fileType/updateType', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/file.js